export default "__VITE_ASSET__a89f008e__"